import React from 'react';
import { Query } from '@apollo/client/react/components';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import ActivityFeedRankingsWidget from 'buyside/components/presentation/ActivityFeedRankingsWidget/activityFeedRankingsWidget';
import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import RankingsWidgetItem from 'buyside/components/presentation/ActivityFeedRankingsWidget/RankingsWidgetItem/rankingsWidgetItem';

import {
  userUrl,
  employerProfileUrl,
  defaultUserImageUrl,
  userIdeaUrl
} from 'buyside/util/urlHelper';

import { Maybe, RankingsWidgetQuery as RankingsWidgetQueryData } from 'interfaces/graphql-typings';

const RankingsWidgetQuery = require('buyside/graphql/queries/RankingsWidget');

const RankingsWidgetContainer: React.FunctionComponent = (): React.ReactElement => {
  return (
    <ErrorBoundary pageName="Rankings Widget">
      <Query<RankingsWidgetQueryData, { category: string; first: number }>
        query={RankingsWidgetQuery}
        variables={{ category: 'last_twelve_months', first: 3 }}
      >
        {({ loading, data = {} }): Maybe<React.ReactElement> => {
          if (loading || !data) {
            return <LoadingSpinner size={SIZES.MEDIUM} />;
          }
          if (!data.currentRanksForCategory || !data.currentUser) {
            return null;
          }

          const {
            currentUser: { canViewUserDetails },
            currentRanksForCategory: { edges }
          } = data;

          return (
            <ActivityFeedRankingsWidget>
              {edges?.map((edge, idx) => {
                if (!edge?.node) return null;

                const { id, user } = edge.node;
                if (!user) return null;

                const {
                  id: userId,
                  displayName,
                  mostRecentEmployer,
                  profileCity,
                  profileImageUrl
                } = user;
                const { isCurrentEmployer, employer, title } = mostRecentEmployer || {};
                const { id: employerId, name, fundType } = employer || {};

                return (
                  <RankingsWidgetItem
                    key={id}
                    userImageUrl={profileImageUrl || defaultUserImageUrl()}
                    userName={displayName}
                    userProfileUrl={userUrl(userId)}
                    publicUserIdeaUrl={userIdeaUrl(userId)}
                    subtitle={(isCurrentEmployer ? name : profileCity) || ''}
                    employerProfileUrl={
                      isCurrentEmployer && employerId ? employerProfileUrl(employerId) : null
                    }
                    rankNumber={idx + 1}
                    showUserDetails={Boolean(canViewUserDetails)}
                    anonAuthor={{ title: title || '' }}
                    employerType={isCurrentEmployer && fundType ? fundType : null}
                    profileCity={profileCity || ''}
                  />
                );
              })}
            </ActivityFeedRankingsWidget>
          );
        }}
      </Query>
    </ErrorBoundary>
  );
};

export default RankingsWidgetContainer;
